// Namespace
var MG = {};

// ==============================================================================
// Constants
// ==============================================================================

var NAMESPACE_SVG = 'http://www.w3.org/2000/svg';
var NAMESPACE_XLINK = 'http://www.w3.org/1999/xlink';

//

MG.BARRIERS_ROOT_ELEMENT_ID = 'barriers';
MG.HUD_ROOT_ELEMENT_ID = 'hud';
MG.MENU_ROOT_ELEMENT_ID = 'menu';

MG.BARRIER_SPACING = 650.0;
MG.TUNNEL_RADIUS = 100;
MG.MISSILE_LENGTH = 50.0;

MG.LINE_OF_SIGHT = 1600.0;
MG.FIELD_OF_VIEW = 60.0;
MG.PROJECTION_PLANE_DISTANCE = 100;

export { MG, NAMESPACE_SVG, NAMESPACE_XLINK };
